/**
 * Normalized paginated list response used across list endpoints.
 * Backend may return Ninja shape ({ items, count }) or custom ({ results, total });
 * we normalize to this shape everywhere.
 */
export interface PaginatedResponse<T> {
  results: T[];
  total: number;
}

/**
 * Raw paginated response from API (Ninja uses items/count; network devices use results/total).
 */
type RawPaginatedPayload<T> = {
  items?: T[];
  results?: T[];
  count?: number;
  total?: number;
};

/**
 * Normalize API pagination response to { results, total }.
 * Handles both Django Ninja (@paginate: items/count) and custom (results/total) responses.
 */
export function normalizePaginatedResponse<T>(
  data: RawPaginatedPayload<T> | null | undefined
): PaginatedResponse<T> {
  if (!data) {
    return { results: [], total: 0 };
  }
  const results = data.results ?? data.items ?? [];
  const total = data.total ?? data.count ?? results.length;
  return { results: Array.isArray(results) ? results : [], total: Number(total) };
}
